// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h0pxC","content":"styles_content__2vYKx","tableWrap":"styles_tableWrap__3R7iC"};